import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Menu,
  Home,
  Settings,
  ChevronDown,
  ChevronRight,
  TrendingUpDown,
  Shapes,
  Coins,
  Users,
  Quote,
  LayoutDashboard,
} from "lucide-react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import UserDropdown from "./UserProfile";
import { AuthContext } from "../../Context/ContextFunctions";
import { User, LogOut } from "lucide-react";
import SuryaLogoMain from "../../assets/images/SuryaLogoMain.png";
import LogoutConfirmModal from "./LogoutConfirmModal";
import NotificationBell from "../NotificationBell";
import NotificationPanel from "../NotificationPanel";
import NotificationDetailsModal from "../NotificationDetailsModal";
import { GetNotificationCount, GetNotificationList } from "../../services/Notification/NotificationApi";
import { useNotifications } from "../../Context/NotificationContext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isMasterOpen, setIsMasterOpen] = useState(false);
  const [isSourceOpen, setIsSourceOpen] = useState(false);
  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const [isCityOpen, setIsCityOpen] = useState(false);
  const [isStateOpen, setIsStateOpen] = useState(false);
  const [userProfile, setShowUserProfile] = useState(false);
  const [mobileMenu, showMobileMenu] = useState(false);
  const [showConfirmationModal, setConfirmationModal] = useState(false);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { authDetails, isAccessible } = useContext(AuthContext);
  const profileRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { notificationCount, setNotificationCount, setNotifications, isNotificationUpdate, setIsNotificationUpdate } = useNotifications();
  const prevCountRef = useRef(notificationCount);

  const togglePanel = () => {
    GetNotificationListData();
    setOpen(!open);

  }

  const location = useLocation();
  const [isReportOpen, setIsReportOpen] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      const isProfile = profileRef.current?.contains(event.target);
      const isNotificationPanel = document.getElementById("notification-panel")?.contains(event.target);

      // Only close profile panel if clicking outside both
      if (!isProfile && !isNotificationPanel) {
        setShowUserProfile(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {

    if ((authDetails?.userKeyID !== null && authDetails?.userKeyID !== undefined && authDetails?.userKeyID !== "") || isNotificationUpdate) {
      GetNotificationCountData()
      if (isNotificationUpdate) {
        setIsNotificationUpdate(false)
      }
    }
  }, [authDetails, isNotificationUpdate])

  useEffect(() => {
    GetNotificationCountData();
    const interval = setInterval(() => {
      GetNotificationCountData();
    }, 1 * 60 * 1000); // 3 minutes

    return () => clearInterval(interval);
  }, []);


  const GetNotificationCountData = async () => {

    try {
      const response = await GetNotificationCount(authDetails?.userKeyID);
      if (response.data?.statusCode === 200) {
        const count = response.data?.responseData?.notificationCount || [];
        setNotificationCount(count)
        if (count > prevCountRef.current) {
          setOpen(!open);
        }
        prevCountRef.current = count;
        GetNotificationListData()
      }

    } catch (error) {

      console.log(error);
    }
  };

  const GetNotificationListData = async () => {

    try {
      const response = await GetNotificationList(authDetails?.userKeyID);
      if (response.data?.statusCode === 200) {
        const list = response.data?.responseData?.data || [];
        setNotifications(list)

      }

    } catch (error) {

      console.log(error);
    }
  };
  const handleMouseEnter = (item) => {
    if (window.innerWidth >= 1024) {
      // lg breakpoint
      setHoveredItem(item);
      if (item === "Master") setIsMasterOpen(true);
      if (item === "AdminReport") setIsReportOpen(true);
    }
  };

  const handleMouseLeave = (item) => {
    if (window.innerWidth >= 1024) {
      if (item === "Master") setIsMasterOpen(false);
      if (item === "AdminReport") setIsReportOpen(false);
      setHoveredItem(null);
    }
  };

  const toggleMaster = () => {
    if (window.innerWidth < 1024) {
      setIsMasterOpen(!isMasterOpen);
      // Close source and type when master is toggled
      setIsSourceOpen(false);
      setIsTypeOpen(false);
    }
  };

  const toggleSource = () => {
    if (window.innerWidth < 1024) {
      // Close type if source is being opened
      if (!isSourceOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsSourceOpen(!isSourceOpen);
    }
  };

  const toggleType = () => {
    if (window.innerWidth < 1024) {
      // Close source if type is being opened
      if (!isTypeOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsTypeOpen(!isTypeOpen);
    }
  };

  const toggleCity = () => {
    if (window.innerWidth < 1024) {
      if (!isCityOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsCityOpen(!isCityOpen);
    }
  };

  const toggleState = () => {
    if (window.innerWidth < 1024) {
      if (!isStateOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsStateOpen(!isStateOpen);
    }
  };
  const toggleAdminReport = () => {
    if (window.innerWidth < 1024) {
      setIsReportOpen(!isReportOpen);
      // Close source and type when master is toggled
      setIsSourceOpen(false);
      setIsTypeOpen(false);
    }
  };

  const handleLogout = () => {
    setConfirmationModal(true); // Open confirmation modal
  };

  const onConfirmBtnClicked = () => {
    localStorage.clear(); // Clear localStorage
    navigate("/login"); // Redirect to login page
    window.location.reload(); // Refresh the page
    setConfirmationModal(false); // Close modal
  };

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      return "Good Morning";
    } else if (hour >= 12 && hour < 17) {
      return "Good Afternoon";
    } else if (hour >= 17 && hour < 21) {
      return "Good Evening";
    } else {
      return "Good Night";
    }
  };
  const firstName = authDetails.employeeName?.split(" ")[0] || "";
  const greetingMessage = `${getGreeting()}, ${firstName}`;

  const closePanel = () => setOpen(false);
  return (
    <>
      {/* Navigation menu */}
      <nav class="bg-blue-600">
        <div class="mx-auto  px-2 sm:px-6 lg:px-8 rep-width">
          <div class="relative flex h-16 items-center justify-between">
            <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
              {/* <!-- Mobile menu button--> */}
              <button
                type="button"
                class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset"
                aria-controls="mobile-menu"
                aria-expanded="false"
                onClick={() => showMobileMenu(!mobileMenu)}
              >
                <span class="absolute -inset-0.5"></span>
                <span class="sr-only">Open main menu</span>
                {/* <!--
            Icon when menu is closed.

            Menu open: "hidden", Menu closed: "block"
          --> */}
                <svg
                  class="block size-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                  />
                </svg>
                {/* <!--
            Icon when menu is open.

            Menu open: "block", Menu closed: "hidden"
          --> */}
                <svg
                  class="hidden size-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
              {/* <div class="flex shrink-0 items-center">
                <img
                  class="h-6 w-auto rounded-full"
                  src={LogoutConfirmModal}
                  alt="Your Company"
                />
              </div> */}
              <div class="hidden sm:block">
                <div class="flex space-x-4">
                  {/* <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" --> */}
                  {/* Dashboard Link */}
                  <Link
                    to="/"
                    className={`
              flex items-center gap-1 
              px-3 py-2 
              text-gray-200 
              hover:text-white hover:bg-[#4775ff]/50 
              transition-all duration-200 
              rounded-md
              ${location.pathname === "/" ? "bg-[#1a4dff] text-white" : ""}
            `}
                    onClick={() => setIsOpen(false)}
                  >
                    <LayoutDashboard size={18} />
                    {/* <Home  /> */}
                    <p
                      className="text-sm font-medium font-[Poppins]"
                      style={{ width: "max-content" }}
                    >
                      Dashboard
                    </p>
                  </Link>
                  {/* Lead */}
                  {isAccessible?.Lead?.canView && (
                    <Link
                      to="/lead"
                      className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50 
transition-all duration-200 
rounded-md
${location.pathname === "/lead" ? "bg-[#1a4dff] text-white" : ""}
`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Shapes size={18} />
                      <p className="text-sm font-medium font-[Poppins]">Lead</p>
                    </Link>
                  )}

                  {/* Add your other navigation links here */}
                  {/* ... rest of your navigation links ... */}

                  {/* Enquiry Received */}
                  {isAccessible?.EnquiryReceived.canView && (
                    <Link
                      to="/enquiry-received"
                      className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50
transition-all duration-200 
rounded-md
${location.pathname === "/enquiry-received"
                          ? "bg-[#1a4dff] text-white"
                          : ""
                        }

`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Shapes size={18} />
                      <p
                        className="text-sm font-medium font-[Poppins]"
                        style={{ width: "max-content" }}
                      >
                        Enquiry Received
                      </p>
                    </Link>
                  )}


                  {/* EST & BOQ */}
                  {/* {isAccessible?.EstBoq.canView && (
                    <Link
                      to="/estBoq"
                      className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50
transition-all duration-200 
rounded-md
${location.pathname === "/estBoq" ? "bg-[#1a4dff] text-white" : ""}
`}
                      onClick={() => setIsOpen(false)}
                    >
                      <TrendingUpDown size={18} />
                      <p
                        className="text-sm font-medium font-[Poppins]"
                        style={{ width: "max-content" }}
                      >
                        EST & BOQ
                      </p>
                    </Link>
                  )} */}


                  {/* Quotation */}
                  {isAccessible?.Quotation.canView && (
                    <Link
                      to="/quotation"
                      className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50
transition-all duration-200 
rounded-md
${location.pathname === "/quotation" ? "bg-[#1a4dff] text-white" : ""}
`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Quote size={18} />
                      <p className="text-sm font-medium font-[Poppins]">
                        Quotation
                      </p>
                    </Link>
                  )}


                  {/* Sales Log */}
                  {isAccessible?.SalesLog.canView && (
                    <Link
                      to="/salesLog"
                      className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50
transition-all duration-200 
rounded-md
${location.pathname === "/salesLog" ? "bg-[#1a4dff] text-white" : ""}
`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Users size={18} />
                      <p
                        className="text-sm font-medium font-[Poppins]"
                        style={{ width: "max-content" }}
                      >
                        Sales Log
                      </p>
                    </Link>
                  )}


                  {/* Account LOg */}
                  {isAccessible?.AccountLog.canView && (
                    <Link
                      to="/accountLog"
                      className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50
transition-all duration-200 
rounded-md
${location.pathname === "/accountLog" ? "bg-[#1a4dff] text-white" : ""}
`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Users size={18} />
                      <p
                        className="text-sm font-medium font-[Poppins]"
                        style={{ width: "max-content" }}
                      >
                        Account Log
                      </p>
                    </Link>
                  )}

                  {/*Task Management */}
                  {isAccessible?.TaskManagement?.canView && (
                    <Link
                      to="/task-management"
                      className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50
transition-all duration-200 
rounded-md
${location.pathname === "/task-management" ? "bg-[#1a4dff] text-white" : ""}
`}
                      onClick={() => setIsOpen(false)}
                    >
                      <Users size={18} />
                      <p
                        className="text-sm font-medium font-[Poppins]"
                        style={{ width: "max-content" }}
                      >
                        Task
                      </p>
                    </Link>
                  )}




                </div>
              </div>
            </div>
            <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">

              {/* Notification */}
              <NotificationBell togglePanel={togglePanel} />
              {/* <!-- Profile dropdown --> */}
              <div
                ref={profileRef}
                class="relative mx-5"
              // onMouseEnter={() => setShowUserProfile(true)}
              // onMouseLeave={() => setShowUserProfile(false)}
              >
                <div
                // style={{
                //   marginRight: "5px",
                // }}
                >
                  <button
                    type="button"
                    className="relative flex rounded-full bg-gray-800 text-sm focus:outline-none"
                    id="user-menu-button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    onClick={() => setShowUserProfile(!userProfile)}
                  >
                    <span className="absolute -inset-1.5"></span>
                    <span className="sr-only">Open user menu</span>
                    <img
                      className="h-12 w-12 rounded-full object-cover"
                      src={SuryaLogoMain}
                      alt="User profile"
                    />
                  </button>

                </div>

                {/* <!--
            Dropdown menu, show/hide based on menu state.

            Entering: "transition ease-out duration-100"
              From: "transform opacity-0 scale-95"
              To: "transform opacity-100 scale-100"
            Leaving: "transition ease-in duration-75"
              From: "transform opacity-100 scale-100"
              To: "transform opacity-0 scale-95"
          --> */}
                {userProfile && (
                  <div
                    class="absolute right-0 z-20 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 focus:outline-hidden"
                    role="menu"
                    style={{ width: "max-content" }}
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabindex="-1"
                  >
                    {/* <!-- Active: "bg-gray-100 outline-hidden", Not Active: "" --> */}
                    {/* <UserDropdown /> */}
                    <div>
                      <span className="text-sm font-bold px-5">
                        {`${greetingMessage}`}
                      </span>
                    </div>
                    <Link
                      to="/profile"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-400"
                      onClick={() => setShowUserProfile(false)}
                    >
                      <User size={16} className="mr-2" />
                      Profile
                    </Link>
                    <button
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-400 w-full text-left"
                      onClick={() => {
                        handleLogout();
                        setShowUserProfile(false);
                      }}
                    >
                      <LogOut size={16} className="mr-2" />
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Mobile menu, show/hide based on menu state. --> */}
        <div class="sm:hidden" id="mobile-menu">
          {mobileMenu && (
            <div class="space-y-1 px-2 pt-2 pb-3">
              {/* <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" --> */}
              {/* Dashboard Link */}
              <Link
                to="/"
                className={`
              flex items-center gap-1 
              px-3 py-2 
              text-gray-200 
              hover:text-white hover:bg-[#4775ff]/50 
              transition-all duration-200 
              rounded-md
              ${location.pathname === "/" ? "bg-[#1a4dff] text-white" : ""}
            `}
                onClick={() => setIsOpen(false)}
              >
                <Home size={18} />
                <p className="text-sm font-medium font-[Poppins]">Dashboard</p>
              </Link>
              {/* Lead */}
              <Link
                to="/lead"
                className={`
              flex items-center gap-1 
              px-3 py-2 
              text-gray-200 
              hover:text-white hover:bg-[#4775ff]/50 
              transition-all duration-200 
              rounded-md
              ${location.pathname === "/lead" ? "bg-[#1a4dff] text-white" : ""}
            `}
                onClick={() => setIsOpen(false)}
              >
                <Shapes size={18} />
                <p className="text-sm font-medium font-[Poppins]">Lead</p>
              </Link>
              {/* Add your other navigation links here */}
              {/* ... rest of your navigation links ... */}

              {/* Enquiry Received */}
              <Link
                to="/enquiry-received"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
              ${location.pathname === "/enquiry-received"
                    ? "bg-[#1a4dff] text-white"
                    : ""
                  }
       
    `}
                onClick={() => setIsOpen(false)}
              >
                <Shapes size={18} />
                <p className="text-sm font-medium font-[Poppins]">
                  Enquiry Received
                </p>
              </Link>

              {/* EST & BOQ */}
              <Link
                to="/estBoq"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/estBoq" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => setIsOpen(false)}
              >
                <TrendingUpDown size={18} />
                <p className="text-sm font-medium font-[Poppins]">EST & BOQ</p>
              </Link>

              {/* Quotation */}
              <Link
                to="/quotation"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/quotation" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => setIsOpen(false)}
              >
                <Quote size={18} />
                <p className="text-sm font-medium font-[Poppins]">Quotation</p>
              </Link>

              {/* Sales Log */}
              <Link
                to="/salesLog"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/salesLog" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => setIsOpen(false)}
              >
                <Users size={18} />
                <p className="text-sm font-medium font-[Poppins]">Sales Log</p>
              </Link>

              {/* Account LOg */}
              <Link
                to="/accountLog"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/accountLog" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => setIsOpen(false)}
              >
                <Users size={18} />
                <p className="text-sm font-medium font-[Poppins]">
                  Account Log
                </p>
              </Link>

              {/* DVR */}
              {/* <Link
                to="/dvr"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/dvr" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => setIsOpen(false)}
              >
                <Users size={18} />
                <p className="text-sm font-medium font-[Poppins]">DVR</p>
              </Link> */}

              {/* follow up */}
              {/* <Link
                to="/followup"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/followup" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => setIsOpen(false)}
              >
                <Users size={18} />
                <p className="text-sm font-medium font-[Poppins]">Follow-up</p>
              </Link> */}
              <Link
                to="/task-management"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/task-management" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => setIsOpen(false)}
              >
                <Users size={18} />
                <p className="text-sm font-medium font-[Poppins]">Task</p>
              </Link>
            </div>
          )}
        </div>
      </nav>

      {showConfirmationModal && (
        <LogoutConfirmModal
          show={showConfirmationModal}
          onHide={() => setConfirmationModal(false)}
          onConfirm={onConfirmBtnClicked}
        />
      )}

      {open && (
        <div

          className="fixed inset-0 bg-black/30 backdrop-blur-s z-40"
        />
      )}

      <NotificationPanel isOpen={open} onClose={closePanel} />

      {/* Details Modal */}
      <NotificationDetailsModal />

    </>
  );
};
export default Navbar;
